var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_452_955)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.11111 0C0.816426 0 0.533811 0.117063 0.325437 0.325437C0.117063 0.533811 0 0.816426 0 1.11111V8.88889C0 9.18357 0.117063 9.46619 0.325437 9.67456C0.533811 9.88294 0.816426 10 1.11111 10H8.88889C9.18357 10 9.46619 9.88294 9.67456 9.67456C9.88294 9.46619 10 9.18357 10 8.88889V1.11111C10 0.816426 9.88294 0.533811 9.67456 0.325437C9.46619 0.117063 9.18357 0 8.88889 0H1.11111ZM7.75 3.77556C7.85425 3.67138 7.91284 3.53007 7.91289 3.3827C7.91294 3.23532 7.85445 3.09397 7.75028 2.98972C7.64611 2.88548 7.50479 2.82688 7.35742 2.82683C7.21005 2.82678 7.06869 2.88527 6.96445 2.98944L4.21445 5.73944L3.03611 4.56111C2.98453 4.50949 2.92329 4.46854 2.85588 4.44059C2.78848 4.41265 2.71622 4.39825 2.64325 4.39822C2.49588 4.39817 2.35452 4.45666 2.25028 4.56083C2.14603 4.665 2.08744 4.80632 2.08739 4.95369C2.08734 5.10106 2.14583 5.24242 2.25 5.34667L3.78222 6.87889C3.83897 6.93567 3.90635 6.98071 3.98052 7.01144C4.05468 7.04216 4.13417 7.05798 4.21445 7.05798C4.29472 7.05798 4.37421 7.04216 4.44837 7.01144C4.52254 6.98071 4.58992 6.93567 4.64667 6.87889L7.75 3.77556Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_452_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.0841740963a78159a4f0b26abe654f73.svg";
export { ForwardRef as ReactComponent };